import { ICenter } from './center';

export interface ICenterListResponse {
    data: {
        success: boolean;
        message: string;
        results: ICenter[];
    }
}
